// removed by extract-text-webpack-plugin
module.exports = {"block":"OuterWrapper__block-c1mbO"};